export const WISESHEETS_API_URL = 'https://internal.wisesheets.io'
export const demoTickers = [
    'AAPL',
    'AMZN',
    'TSLA',
    'BTCUSD',
    'ETHUSD',
    'USDTUSD',
    'CADUSD',
    'EURUSD',
]
export const demoFundTickers = ['SPY', 'IYE', 'PICK']
